module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_axios@0.20.0@axios/index.js
// module id = 5
// module chunks = 0